import React from "react";
import { useDispatch } from "react-redux";

import { openModal } from "reducers/Modal";
import { MODAL_TYPES } from 'utils/constants';
import { Icon } from "rhombus-react";

export default function DecisionSheetImportSocketError(props) {
	const {
		timestamp,
		prettyTime,
		iconInfo,
		error,
		data,
		clearMessage,
	} = props || {};
	const libraryName = data.creative?.creativeLibrary?.name || "Library";
	const dispatch = useDispatch();

	function viewErrors(e){
		e.preventDefault();
		dispatch(openModal(MODAL_TYPES.IMPORT_DECISION_SHEET_ERROR, error));
	}

	return (
		<>
			<i key="status-icon" className={`ft-ic status-icon ${iconInfo.icon}`} title={iconInfo.title} />
			<div key="body" className="message-body">
				<p>{error.description}</p>
				<a href="#" onClick={viewErrors} >View Errors</a>
			</div>
			<Icon key="clear" name="clear" iconStyle="fal" className="clear-message" title="Clear Message" onClick={clearMessage} />
			<b key="empty" />
			<span key="footer" className="message-footer name-overflow" title={libraryName}>{libraryName}</span>
			<time key="time" className="message-time" dateTime={timestamp}>{prettyTime}</time>
		</>
	);
}
